import React from 'react'
import Modal from '../../Modal'
import Button from '../../Button'
import useCustomerAddress from '../../../hooks/useCustomerAddress'
import styles from './DeleteAddressModal.module.scss'
import { useTranslation } from 'next-i18next'

const DeleteAddressModal = ({ open, closeModal, id, customerId, setIsError, refreshCustomerAddress }) => {
  const { newDeleteAddress } = useCustomerAddress()
  const { t } = useTranslation('accountPage')
  const deleteAction = () => {
    newDeleteAddress(id, customerId).then(({ response }) => {
      if (response) {
        setIsError(false)
        refreshCustomerAddress()
      }
    })
  }

  return (
    <Modal open={open} onClose={closeModal} className={styles.modal}>
      <h1 className={styles.header}>{t('deleteAddress')}</h1>
      <p className={styles.description}>{t('deleteModalDesc')}</p>
      <div className={styles.buttonContainer}>
        <Button onClick={deleteAction} className={styles.deleteButton}>
          {t('delete')}
        </Button>
        <Button onClick={closeModal} className={styles.cancelButton}>
          {t('cancel')}
        </Button>
      </div>
    </Modal>
  )
}

export default DeleteAddressModal
